enum OrderClaimRefundActions {
    request_refund = 'request_refund',
    cancel_request = 'cancel_request'
}

export { OrderClaimRefundActions }